import { render, staticRenderFns } from "./TrinityRingsSpinner.vue?vue&type=template&id=255e911c&scoped=true"
import script from "./TrinityRingsSpinner.vue?vue&type=script&lang=js"
export * from "./TrinityRingsSpinner.vue?vue&type=script&lang=js"
import style0 from "./TrinityRingsSpinner.vue?vue&type=style&index=0&id=255e911c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../vue-loader@15.11.1_babel-core@6.26.3_css-loader@4.3.0_lodash@4.17.21_prettier@1.19.1_vue-temp_lls4wxv5ipnxzldxaoogv2ybrq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255e911c",
  null
  
)

export default component.exports